import * as React from 'react';
import { Component } from 'react';
import propz from 'propz';
import { AppUser } from 'Src/views/App/App';
import { TABS } from 'Src/consts/common';
import {
  SchoolEvent,
  SchoolEventAttendance,
  SchoolEventIndividualData,
  SchoolEventIndividualPerformance,
  SchoolEventTeamDataPlayer
} from 'Src/models/event';
import { getEventPlayers } from 'Src/helpers/event/event';
import { getStudentEventViewTabs, isClubEvent, isHousesEvent } from '../../../../../helpers/event/event';
import { SchoolEventGroupedTabs } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/SchoolEventGroupedTabs';
import { LazyEventCommunications as EventCommunications } from 'Src/components/EventCommunications/LazyEventCommunications';
import { EmptyComponent } from 'Src/components/EmptyComponent/EmptyComponent';
import { StudentEventDetailsSummaryTab } from './DetailsTab/DetailsTab';
import { StudentEventJobsSummaryTab } from './JobsTab/JobsTab';
import { StudentEventPerformanceSummaryTab } from './PerformanceTab/PerformanceTab';
import { Loader } from 'Src/components/Loader/Loader';
import { StudentEventTeamsSummaryTab } from './TeamsTab/TeamsTab';
import './SummaryTabs.scss';
import { getSchoolEventDetails, getSchoolEventMatchReport } from '../../../../../helpers/service/admin/schoolEvents';
import { getEventTasks } from '../../../../../helpers/service/admin/event';
import { StudentEventMatchReportSummaryTab } from './MatchReportTab/MatchReportTab';
import {
  SchoolEventPlayerSummary,
  SchoolEventTeamSummary
} from '../../../../../components/SchoolEventPlayersSummary/SchoolEventPlayersSummary';
import { StudentEventPlayersPositionsSummary } from './PositionsTab/PositionsTab';
import { Sport } from '../../../../../models/sport';
import { DEFAULT_LIMIT, DEFAULT_SKIP } from '../../../../../consts/table';
import { getSchoolSportsPublic } from '../../../../../helpers/service/public/public';
import { Report } from '../../../../../models/report';
import { getStudentAvailabilityReports } from '../../../../../helpers/service/admin/messages';
import BPromise from 'bluebird';
import { StudentEventAvailabilityReportsSummaryTab } from './StudentEventAvailabilityReportsSummaryTab/StudentEventAvailabilityReportsSummaryTab';
import { VenueView } from '../../../../../components/VenueView/VenueView';
import { SimpleModal } from '../../../../../components/SimpleModal/SimpleModal';
import { Point } from '../../../../../models/venue';
import { SchoolEventIndividualDiscipline } from '../../../../../models/event';
import { StudentEventDisciplineSummaryTab } from './DisciplineTab/DisciplineTab';
import { StudentEventAttendanceSummaryTab } from './AttendanceTab/AttendanceTab';
import { Button } from 'Src/components/Button/Button';
import { ACCESS_PRESET } from 'Src/consts/album';
import { Video } from 'Src/models/video';
import { Photo } from 'Src/models/photo';
import { EventGallery } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Gallery/Gallery';
import { EventVideos } from 'Src/views/GenericView/AdminView/TeamsAndEvents/Events/SchoolEventView/Videos/EventVideos';
import {
  getStudentEventPhotos,
  addStudentEventPhoto,
  deleteStudentEventPhoto
} from 'Src/helpers/service/student/events';
import { getAllEventVideos, updateEventVideo } from 'Src/helpers/service/admin/eventVideos';
import { ACCESS_PRESET_TYPE } from 'Src/types/album';
import { uploadImage } from 'Src/helpers/service/image';
import { getStudentAwardsCurrent } from 'Src/helpers/service/student/awards';
import { hasVisibleEventDetails } from 'Src/components/EventDetailsSummary/EventDetailsSummary';
import { SchoolEventAwardsSummary } from 'Src/components/SchoolEventAwardsSummary/SchoolEventAwardsSummary';

interface Props {
  user: AppUser;
  eventInitial: SchoolEvent;
  onEditAvailability?: (report: Report) => void;
  initialTab?: string;
  initialConversationId?: string;
}

const countPendingAvailability = (reports: Report[]): number => {
  const latestByStudent = new Map<string, Report>();
  reports.forEach((report, index) => {
    const key = String(
      propz.get(report, ['playerDetails', 'userId'], '') ||
        propz.get(report, ['playerDetails', 'permissionId'], '') ||
        propz.get(report, ['playerDetailsData', 'id'], '') ||
        index
    );
    const current = latestByStudent.get(key);
    if (!current || new Date(report.createdAt).getTime() > new Date(current.createdAt).getTime()) latestByStudent.set(key, report);
  });
  return Array.from(latestByStudent.values()).filter(report => {
    if (typeof report.isTakePart === 'boolean') return false;
    const cutoff = (report as any).availabilityDeadline || propz.get(report, ['eventData', 'startTime'], '');
    return !cutoff || new Date(cutoff).getTime() > Date.now();
  }).length;
};

interface State {
  currentTabIndex: number;
  eventTaskIndex: number;
  eventDetails: any;
  isLoading: boolean;
  isErrorModalOpen: boolean;
  errorMessage: string;
  eventTasks: any[];
  individualPerformance: SchoolEventIndividualPerformance[];
  individualDiscipline: SchoolEventIndividualDiscipline[];
  attendancePlayers: SchoolEventAttendance[];
  event: SchoolEvent;
  matchReport: string;
  sports: Sport[];
  playersForSummary: SchoolEventPlayerSummary[];
  teamsForSummary: SchoolEventTeamSummary[];
  activeTeamIndex: number;
  reports: Report[];
  isVenueFormOpen: boolean;
  point: Point;
  photos: Photo[];
  videos: Video[];
  isUpdateAccessPreset: boolean;
  awards: any[];
}

export class StudentSummaryTabs extends Component<Props, State> {
  private loadRequestId = 0;
  private initialTabApplied = false;
  photoFileInputRef: any;

  constructor(props: Props) {
    super(props);

    this.state = {
      currentTabIndex: 0,
      eventTaskIndex: 0,
      eventDetails: undefined,
      isLoading: true,
      isErrorModalOpen: false,
      errorMessage: '',
      eventTasks: [],
      individualPerformance: [],
      individualDiscipline: [],
      attendancePlayers: [],
      event: props.eventInitial,
      matchReport: '',
      sports: [],
      playersForSummary: [],
      teamsForSummary: [],
      activeTeamIndex: 0,
      reports: [],
      isVenueFormOpen: false,
      point: undefined,
      photos: [],
      videos: [],
      isUpdateAccessPreset: false,
      awards: []
    };
  }

  componentDidMount() {
    this.setState({
      isLoading: true
    });
    this.setItems();
  }

  componentWillUnmount() {
    this.loadRequestId += 1;
  }

  private showRequestError = (error: any, fallbackMessage: string) => {
    const errorText =
      propz.get(error, ['response', 'data', 'details', 'text'], '') ||
      propz.get(error, ['response', 'data', 'message'], '') ||
      propz.get(error, ['message'], '') ||
      fallbackMessage;
    this.setState({ isLoading: false, errorMessage: errorText, isErrorModalOpen: true });
  };

  setItems(): Promise<void> {
    const requestId = ++this.loadRequestId;
    const { user } = this.props;
    const { event, currentTabIndex } = this.state;
    const currentTab = this.getTabs()[currentTabIndex];
    const tabToRestore = !this.initialTabApplied && this.props.initialTab ? this.props.initialTab : currentTab;

    this.setState({
      isLoading: true
    });
    const studentId = propz.get(user, ['profile', 'id'], user.userId);
    return BPromise.all([
      getStudentAvailabilityReports(user, event.id),
      getSchoolEventDetails(user, event.id),
      getEventTasks(user, event.id),
      getStudentAwardsCurrent(user, {
        limit: 100,
        order: 'awardedAt DESC',
        where: { eventId: event.id }
      })
    ])
      .then(([reports, eventDetails, allEventTasks, awards]) => {
        if (requestId !== this.loadRequestId) return;
        const eventTasks = allEventTasks.filter(task =>
          propz.get<any[]>(task, ['assignees'], []).some(assignee => String(assignee.userId) === String(studentId))
        );
        this.setState(
          {
            reports,
            eventDetails,
            eventTasks,
            awards,
            isLoading: false
          },
          () => {
            this.initialTabApplied = true;
            const restoredIndex = tabToRestore ? this.getTabs().indexOf(tabToRestore) : -1;
            if (restoredIndex >= 0 && restoredIndex !== this.state.currentTabIndex) {
              this.setState({ currentTabIndex: restoredIndex });
            }
          }
        );
      })
      .catch(error => {
        if (requestId !== this.loadRequestId) return;
        console.error(error);
        this.showRequestError(error, 'Event information could not be loaded. Please try again.');
      });
  }

  getTabs = (): string[] => {
    const { event, reports, eventDetails, eventTasks, awards } = this.state;
    const tabs = getStudentEventViewTabs(
      event,
      reports.length > 0,
      hasVisibleEventDetails(event, eventDetails),
      eventTasks.length > 0,
      awards.length > 0
    ).filter(tab => tab !== TABS.FEED);
    if (!tabs.includes(TABS.COMMUNICATIONS)) tabs.push(TABS.COMMUNICATIONS);
    if (
      (!this.props.user.activeSchool || (this.props.user.activeSchool as any).eventCommunicationsAvailable !== false) &&
      !tabs.includes(TABS.COMMUNICATION_NOTIFICATIONS)
    ) {
      tabs.push(TABS.COMMUNICATION_NOTIFICATIONS);
    }
    return tabs;
  };

  onTabClick = (e, index: number) => {
    e.preventDefault();

    const { user } = this.props;
    const { event } = this.state;
    const { id, results } = event;
    const tabs = this.getTabs();
    const currentTab = tabs[index];

    const { individualPerformance, individualDiscipline, attendance } = results;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    switch (currentTab) {
      case TABS.DETAILS:
        this.setState({ currentTabIndex: index });
        break;
      case TABS.POSITIONS:
        const playersForSummary = this.getPlayersForSummary(event);
        const teamsForSummary = this.getTeamsForSummary();
        if (this.state.sports.length === 0) {
          const filter = { limit: DEFAULT_LIMIT, order: 'name ASC', skip: DEFAULT_SKIP };
          this.setState({ isLoading: true });
          getSchoolSportsPublic(user.activeSchoolId, filter)
            .then(sports =>
              this.setState({
                currentTabIndex: index,
                playersForSummary,
                teamsForSummary,
                sports,
                isLoading: false
              })
            )
            .catch(error => {
              this.showRequestError(error, 'Sports could not be loaded. Please try again.');
            });
        } else {
          this.setState({ currentTabIndex: index, playersForSummary, teamsForSummary });
        }
        break;
      case TABS.ATTENDANCE:
        this.setState({
          currentTabIndex: index,
          attendancePlayers
        });
        break;
      case TABS.JOBS:
        this.setState({ currentTabIndex: index });
        break;
      case isClubEvent(event) ? TABS.PROGRESS : TABS.PERFORMANCE:
        this.setState({
          currentTabIndex: index,
          individualPerformance: individualPerformance
        });
        break;
      case TABS.DISCIPLINE:
        this.setState({
          currentTabIndex: index,
          individualDiscipline: individualDiscipline
        });
        break;
      case isClubEvent(event) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        this.setState({
          isLoading: true
        });
        getSchoolEventMatchReport(user, id)
          .then(matchReport => {
            const content = propz.get(matchReport, ['content'], '');
            this.setState({
              currentTabIndex: index,
              matchReport: content,
              isLoading: false
            });
          })
          .catch(error => {
            this.showRequestError(error, 'The match report could not be loaded. Please try again.');
          });
        break;

      case TABS.GALLERY: {
        this.setState({
          isLoading: true
        });
        const promises = [getStudentEventPhotos(user, id), getAllEventVideos(user, id)];
        BPromise.all(promises)
          .then(([photos, videos]) => {
            this.setState({
              isLoading: false,
              currentTabIndex: index,
              photos,
              videos
            });
          })
          .catch(error => {
            this.showRequestError(error, 'Event media could not be loaded. Please try again.');
          });
        break;
      }

      default:
        this.setState({
          currentTabIndex: index
        });
    }
  };

  onAccessPresetPhotoClick = (photoId: string, accessPreset: ACCESS_PRESET_TYPE) => {
    return;
  };

  onAccessPresetVideoClick = (videoId: string, accessPreset: ACCESS_PRESET_TYPE) => {
    return;
  };

  onViewMapClick = (point): void => {
    this.setState({
      point: point,
      isVenueFormOpen: true
    });
  };

  getContentTabs(): React.ReactNode {
    const { user } = this.props;
    const { event, reports } = this.state;
    const { activeSchoolId, userId } = user;
    const {
      currentTabIndex,
      eventDetails,
      eventTasks,
      individualPerformance,
      individualDiscipline,
      matchReport,
      sports,
      activeTeamIndex,
      playersForSummary,
      teamsForSummary,
      isUpdateAccessPreset,
      photos,
      videos,
      awards
    } = this.state;

    const tabs = this.getTabs();
    const currentTab = tabs[currentTabIndex];

    const { results } = event;

    const { attendance } = results;
    const attendancePlayers = attendance.map(player => ({ ...player }));

    const allTeamPlayers = getEventPlayers(event, activeSchoolId);
    const currentPlayer = allTeamPlayers.find(player => player.userId === userId);

    const currentSport = sports.find(sport => sport.id === event.sportId);

    switch (currentTab) {
      case TABS.COMMUNICATIONS:
        return <EventCommunications user={user} eventId={event.id} panel="CHATS" initialConversationId={this.props.initialConversationId} />;
      case TABS.COMMUNICATION_NOTIFICATIONS:
        return <EventCommunications user={user} eventId={event.id} panel="SETTINGS" />;
      case TABS.DETAILS:
        return <StudentEventDetailsSummaryTab schoolEvent={event} eventsDetails={eventDetails} />;
      case TABS.POSITIONS:
        return (
          <StudentEventPlayersPositionsSummary
            schoolEvent={event}
            sport={currentSport}
            players={playersForSummary}
            teams={teamsForSummary}
            activeTeamIndex={activeTeamIndex}
            onChangeTeam={this.onChangeTeam}
          />
        );
      case TABS.ATTENDANCE:
        return (
          <StudentEventAttendanceSummaryTab
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            attendancePlayers={attendancePlayers}
            user={user}
          />
        );
      case TABS.JOBS:
        return <StudentEventJobsSummaryTab eventTasks={eventTasks} user={user} />;
      case TABS.AWARDS: {
        const awardTypesById = awards.reduce((result, award) => {
          if (award.awardType && award.awardType.id) result[award.awardType.id] = award.awardType;
          return result;
        }, {});
        const profile: any = user.profile || {};
        const players = [
          {
            userId: profile.id || user.userId,
            permissionId: user.activePermission && user.activePermission.id,
            firstName: profile.firstName,
            lastName: profile.lastName,
            displayName: profile.displayName
          }
        ];
        return <SchoolEventAwardsSummary awards={awards} awardTypesById={awardTypesById} players={players} />;
      }
      case isClubEvent(event) ? TABS.PROGRESS : TABS.PERFORMANCE:
        return (
          <StudentEventPerformanceSummaryTab
            schoolEvent={event}
            currentPlayer={currentPlayer}
            individualPerformance={individualPerformance}
          />
        );
      case TABS.DISCIPLINE:
        return (
          <StudentEventDisciplineSummaryTab
            user={user}
            schoolEvent={event}
            allTeamPlayers={allTeamPlayers}
            individualDiscipline={individualDiscipline}
          />
        );
      case TABS.PARTICIPANTS:
      case TABS.PLAYERS:
        return <StudentEventTeamsSummaryTab user={user} eventInitial={event} />;
      case isClubEvent(event) ? TABS.LEADER_COACH_NOTES : TABS.MATCH_REPORT:
        return <StudentEventMatchReportSummaryTab schoolEvent={event} matchReport={matchReport} />;
      case TABS.AVAILABILITY_REPORTS:
        return (
          <StudentEventAvailabilityReportsSummaryTab
            reports={reports}
            user={user}
            onViewMapClick={this.onViewMapClick}
            onEditReport={this.props.onEditAvailability}
          />
        );

      case TABS.GALLERY:
        return (
          <>
            <EventGallery
              onDeletePhotoClick={this.onDeletePhotoClick}
              user={user}
              eventInitial={event}
              photos={photos}
              onAccessPresetClick={this.onAccessPresetPhotoClick}
              isUpdateAccessPreset={isUpdateAccessPreset}
            />
            <EventVideos
              user={user}
              eventInitial={event}
              videos={videos}
              onAccessPresetClick={this.onAccessPresetVideoClick}
              isUpdateAccessPreset={isUpdateAccessPreset}
            />
          </>
        );

      default:
        return <EmptyComponent />;
    }
  }

  getPlayersForSummary(event: SchoolEvent): SchoolEventPlayerSummary[] {
    const { user } = this.props;
    const { activeSchoolId } = user;

    const schoolPlayers = getEventPlayers(event, activeSchoolId);

    return schoolPlayers.map(schoolPlayer => {
      const { userId, permissionId, firstName, lastName, form, id, teamId } = schoolPlayer;
      const isFormExist = typeof form !== 'undefined';
      const formName = isFormExist ? form.name : '';

      const playerFromEvent = event.players.find(
        player => player.userId === userId && player.permissionId === permissionId
      );

      const positionId = typeof playerFromEvent !== 'undefined' ? playerFromEvent.positionId : '';
      const isCaptain = typeof playerFromEvent !== 'undefined' ? playerFromEvent.isCaptain : false;
      const isSub = typeof playerFromEvent !== 'undefined' ? playerFromEvent.sub : false;

      return {
        name: `${firstName} ${lastName}`,
        playerId: id,
        form: formName,
        positionId: positionId,
        isCaptain: isCaptain,
        isSub: isSub,
        teamId: teamId
      };
    });
  }

  getTeamsForSummary(): SchoolEventTeamSummary[] {
    const { user } = this.props;
    const { activeSchoolId } = user;
    const { event } = this.state;

    return event.teamsData
      .filter(team => team.schoolId === activeSchoolId)
      .map(team => ({
        teamName: team.name,
        teamId: team.id,
        houseName: isHousesEvent(event) ? team.house.name : undefined
      }));
  }

  onChangeTeam = event => {
    const { teamsForSummary } = this.state;
    const teamId = event.target.value;
    const currentTeamIndex = teamsForSummary.findIndex(team => team.teamId === teamId);

    this.setState({
      activeTeamIndex: currentTeamIndex
    });
  };

  onCancelButtonClick = (): void => {
    this.setState({
      isVenueFormOpen: false
    });
  };

  onCloseErrorClick = () => {
    this.setState({
      isErrorModalOpen: false,
      errorMessage: ''
    });
  };

  renderVenueModal() {
    const { point } = this.state;
    return (
      <SimpleModal isOpen={this.state.isVenueFormOpen} title={'Venue'}>
        <VenueView point={point} onOkClick={this.onCancelButtonClick} />
      </SimpleModal>
    );
  }

  renderSendingError(): React.ReactNode {
    const { errorMessage, isErrorModalOpen } = this.state;

    return (
      <SimpleModal
        isOpen={isErrorModalOpen}
        title={'Error'}
        buttonCancelText={'Ok'}
        onCloseClick={this.onCloseErrorClick}
      >
        <pre>{errorMessage}</pre>
      </SimpleModal>
    );
  }

  onPhotoFileChange = event => {
    const { user, eventInitial } = this.props;
    const { id } = eventInitial;
    const image = event.target.files[0];
    const photoAccessPreset = ACCESS_PRESET.PRIVATE;

    this.setState({
      isLoading: true
    });

    uploadImage(user, image)
      .then(response => {
        const picUrl = `${window.apiImg}/images/${response.key}`;
        const data = {
          picUrl: picUrl,
          originalFileName: image.name,
          accessPreset: photoAccessPreset
        };
        return addStudentEventPhoto(user, id, data);
      })
      .then(res => getStudentEventPhotos(user, id))
      .then(photos => {
        this.setState({
          isLoading: false,
          photos: photos
        });
      })
      .catch(error => {
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage:
            propz.get(error, ['response', 'data', 'details', 'text']) ||
            'The photo could not be uploaded. Please try again.'
        });
      });
  };

  renderPhotoFileInput() {
    return (
      <input
        className="eAddPhotoButton_fileInput"
        type="file"
        accept="image/*"
        aria-label="Choose a photo"
        onChange={this.onPhotoFileChange}
        ref={input => (this.photoFileInputRef = input)}
      />
    );
  }

  onDeletePhotoClick = (photoId: string) => {
    const { user } = this.props;
    const { event } = this.state;
    const { id } = event;
    this.setState({ isLoading: true });
    deleteStudentEventPhoto(user, id, photoId)
      .then(() => getStudentEventPhotos(user, id))
      .then(photos => this.setState({ isLoading: false, photos }))
      .catch(error =>
        this.setState({
          isLoading: false,
          isErrorModalOpen: true,
          errorMessage:
            propz.get(error, ['response', 'data', 'details', 'text']) ||
            'The photo could not be deleted. Please try again.'
        })
      );
  };

  onAddPhotoClick = eventDescriptor => {
    let event;
    //This is true only for IE,firefox
    //Dirty hack from https://codeproject.com/Tips/893254/JavaScript-Triggering-Event-Manually-in-Internet-E
    //However, MDN recommend use very similar polyfill https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent#Polyfill
    if (document.createEvent) {
      // To create a mouse event , first we need to create an event and then initialize it.
      event = document.createEvent('MouseEvent');
      event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
    } else {
      event = new MouseEvent('click');
    }
    this.photoFileInputRef.dispatchEvent(event);
    eventDescriptor.stopPropagation();
  };

  render() {
    const { user } = this.props;
    const { currentTabIndex, isLoading, event, isVenueFormOpen, isErrorModalOpen } = this.state;
    const { activeSchool } = user;
    const { settings } = activeSchool;
    const { photosEnabled } = settings;
    const tabs = this.getTabs();
    const contentTabs = this.getContentTabs();
    const currentTab = tabs[currentTabIndex];

    const isShowAddPhotoButton = photosEnabled && currentTab === TABS.GALLERY;

    if (isLoading) {
      return <Loader />;
    }

    const classes = isVenueFormOpen || isErrorModalOpen ? 'mt-3 modal-open' : 'mt-3';
    return (
      <div className={classes}>
        {this.renderVenueModal()}
        {this.renderSendingError()}
        {this.renderPhotoFileInput()}
        <SchoolEventGroupedTabs
          portalRole="student"
          communicationsUser={user}
          communicationsEventId={event.id}
          groupBadges={{ Availability: countPendingAvailability(reports) }}
          onTabClick={this.onTabClick}
          tabs={tabs}
          currentTabIndex={currentTabIndex}
        >
          {isShowAddPhotoButton && (
            <Button
              onClick={this.onAddPhotoClick}
              text={'Add photo'}
              customClass={'sit-btn sit-btn--primary sit-btn--sm'}
            />
          )}
          {contentTabs}
        </SchoolEventGroupedTabs>
      </div>
    );
  }
}
